import { WDialog, WDialogActions, WDialogContent } from '../../wrappers/wrapper';
import styles from './confirm-dialog.module.scss';
import { useState } from 'react';
import Button from 'components/atoms/button/button';
import Input from 'components/molecules/input/input';
import { Typography } from '@mui/material';

export default function ConfirmDialog({
  title,
  text,
  open,
  setOpen,
  image,
  onConfirm,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  confirmationInputText,
  isLeaveAction = false,
}: {
  title?: string;
  text: React.ReactNode;
  open: boolean;
  setOpen: (value: boolean) => void;
  image?: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmationInputText?: string;
  isLeaveAction?: boolean;
}) {
  const [confirmationText, setConfirmationText] = useState('');

  const handleClose = () => {
    setOpen(false);
    setConfirmationText('');
  };

  const handleConfirm = () => {
    if (confirmationText === 'LEAVE') {
      onConfirm();
      handleClose();
    }
  };

  const handleDelete = () => {
    setOpen(false);
    onConfirm();
  };

  const isConfirmationEnabled = !isLeaveAction || confirmationText === confirmationInputText;

  return (
    <WDialog open={open} onClose={handleClose}>
      <div className={styles.confirmDialog}>
        <div className={styles.content}>
          {image && <img className={styles['image']} src={image} alt="warning" />}

          <span className={styles.title}>{title}</span>
          <Typography>{text}</Typography>
          {isLeaveAction && (
            <Input
              value={confirmationText}
              placeholder="Answer"
              onChange={(e) => setConfirmationText(e.target.value)}
            />
          )}
        </div>
        <div className={styles.actions}>
          <Button
            onClick={isLeaveAction ? handleConfirm : handleDelete}
            type="dangerOutline"
            disabled={!isConfirmationEnabled}
            className={styles.confirmButton}
            radius="10rem"
          >
            {confirmText}
          </Button>
          <Button onClick={handleClose} type="primaryOutline" radius="10rem">
            {cancelText}
          </Button>
        </div>
      </div>
    </WDialog>
  );
}
